import { Link } from "react-router-dom";
import "../../styles/components/ProfileSectionCard.css";

const iconMap = {
  user: "👤",
  licence: "🪪",
  specialty: "🩺",
  certificate: "📜",
  resume: "📄",
  document: "📁",
  calendar: "📅",
};

const ProfileSectionCard = ({
  title,
  summary,
  status = "Not Started",
  actionLink,
  icon = "document",
}) => {
  const statusClass = status
    .toLowerCase()
    .replace(/\s+/g, "-");

  return (
    <article className="profile-section-card">
      <div className="profile-section-top">
        <div
          className="profile-section-icon"
          aria-hidden="true"
        >
          {iconMap[icon] || "📋"}
        </div>

        <span
          className={`section-status ${statusClass}`}
        >
          {status}
        </span>
      </div>

      <h3>{title}</h3>

      <p className="profile-section-summary">
        {summary}
      </p>

      <Link
        to={actionLink}
        className="section-manage-btn"
      >
        Manage →
      </Link>
    </article>
  );
};

export default ProfileSectionCard;